<div class="wrapper">
  <div id="ciChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #ciChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>CI graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>